export const templateEditorQuestionsPlaceholders = {
  boolean: [
    'Is this a question?',
    'Is this a really good question?',
    'Is this a truly amazing question?',
    'Is this an outstandingly awesome question?',
    'Is this the most perspicacious question ever asked?',
    'Is this the penultimate metaversal question ever pontificated?',
    'Do I, human, know what penultimate means?',
    'Have we gone too deep?',
    '(introspectively) Should we go deeper?',
    '(pensively) When does it stop?',
    'The real question is: will you stop first?',
    'Human realizes they are in combat with AI infinity and will lose?',
    'Should human see a doctor about its use of free time?',
    'Should human doctor a see about its free of use time?',
    'Wait, what?',
    'What, what?',
    'What what in the house!?',
    'Or the apartment?',
    'AI for the win?',
    'Does this really never end?',
    'I, human, hereby understand this never ends?',
    'Did you sign?',
    'Are you human?',
    'OK so you did sign or you are human?',
    'Yes I signed?',
    'Yes I am human?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Does human know they’ve won?',
    'Human loses. AI wins. Mic has been dropped?',
  ],
  text: ['What needs attention?', 'Can you describe the issue?', `What's your thoughts on this?`],
  int: ['How many items?', 'What’s the quantity?', 'Count of issues?'],
  number: ['What is the value?', 'Enter the reading?', 'What’s the total?'],
  money: ['What’s the cost?', 'How much was spent?', 'Total amount?'],
  user: ['Who is responsible?', 'Assign to whom?', 'Who completed it?'],
  date: ['When did it happen?', 'Select the date?', 'What day was it?'],
  dateTime: ['When exactly?', 'Date and time of issue?', 'When was this done?'],
  dropdown: ['What is the status?', 'Choose the category?', 'Select the type?'],
  checkList: ['Select the issues found', 'Choose the affected areas', 'Mark the missing parts'],
};
